import React from "react";
import { useApp } from "@/contexts/AppContext";

export default function Logo({ size = 56, withWordmark = true, theme = "dark" }) {
    const { lang } = useApp();
    const isDark = theme === "dark";
    return (
        <div className="inline-flex items-center gap-3" data-testid="cafe24-logo">
            <div
                className="rounded-2xl flex items-center justify-center grain border"
                style={{
                    width: size,
                    height: size,
                    background: isDark ? "#1a0f08" : "#fdfaf5",
                    borderColor: isDark ? "#3d2616" : "#e8d8c3",
                }}
            >
                {/* Coffee bean SVG icon, gold */}
                <svg viewBox="0 0 64 64" width={size * 0.6} height={size * 0.6} aria-hidden="true">
                    <defs>
                        <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
                            <stop offset="0" stopColor="#f0c885" />
                            <stop offset="0.5" stopColor="#d4a35c" />
                            <stop offset="1" stopColor="#b48235" />
                        </linearGradient>
                    </defs>
                    <ellipse cx="22" cy="36" rx="14" ry="20" fill="url(#g)" transform="rotate(-22 22 36)" />
                    <ellipse cx="44" cy="34" rx="14" ry="20" fill="url(#g)" transform="rotate(18 44 34)" />
                    <ellipse cx="40" cy="14" rx="6" ry="9" fill="url(#g)" transform="rotate(10 40 14)" />
                    <path d="M16 22 Q22 36 18 50" stroke={isDark ? "#1a0f08" : "#fdfaf5"} strokeWidth="2.5" fill="none" strokeLinecap="round" transform="rotate(-22 22 36)" />
                    <path d="M38 18 Q44 32 40 46" stroke={isDark ? "#1a0f08" : "#fdfaf5"} strokeWidth="2.5" fill="none" strokeLinecap="round" transform="rotate(18 44 34)" />
                </svg>
            </div>
            {withWordmark && (
                <div className="flex flex-col leading-none">
                    {lang === "ar" ? (
                        <>
                            <span className="font-ar text-2xl font-bold gold-text">كافيه ٢٤</span>
                            <span className="font-display-en text-xs text-muted-foreground mt-1">Café 24</span>
                        </>
                    ) : (
                        <>
                            <span className="font-display-en text-2xl italic font-semibold gold-text">Café 24</span>
                            <span className="font-ar text-xs text-muted-foreground mt-1">كافيه ٢٤</span>
                        </>
                    )}
                </div>
            )}
        </div>
    );
}
